import React, { useEffect, useRef } from 'react';
import { Box, Flex, Input, Tooltip } from '@chakra-ui/react';
import Icons from '../../../Icons';

// The rows of the toolbar's settings popovers (stack, text box).

export const errorStyle = {
  fontSize: '12px',
  color: '#e53e3e',
  paddingTop: '4px',
};
export const hintStyle = {
  fontSize: '12px',
  color: '#666666',
  paddingTop: '4px',
};

// the app's Forms.scss pads every select by 0.5rem and forces a 1.5rem line
// height, which pushes the text out of Chakra's 32px small select. The doubled
// selector outranks that rule.
export const selectStyle = { '&&': { paddingTop: 0, paddingBottom: 0 } };

export const rowLabelStyle = {
  fontSize: '14px',
  display: 'flex',
  alignItems: 'center',
  gap: '0.35rem',
};

/** One setting: label and its explanation on the left, the control on the right. */
export function Row({ label, tip, error, children }) {
  return (
    <Box sx={{ paddingTop: '0.5rem' }}>
      <Flex alignItems="center" justifyContent="space-between" gap="0.75rem">
        <Box sx={rowLabelStyle}>
          <Box>{label}</Box>
          {tip && <InfoTip label={tip} />}
        </Box>
        {children}
      </Flex>
      {error && <Box sx={errorStyle}>{error}</Box>}
    </Box>
  );
}

// a typed field: edits are local until the field is left or Enter is pressed.
// Closing its panel can remove the field without a blur (a click on the canvas
// deselects the object, which takes the panel away first), so an edit still
// pending then is committed as the field goes.
export function NumberField({
  name,
  value,
  onChange,
  onCommit,
  min = 0,
  placeholder,
}) {
  const pending = useRef(false);
  const latestCommit = useRef(onCommit);
  latestCommit.current = onCommit;
  useEffect(
    () => () => {
      if (pending.current) latestCommit.current();
    },
    []
  );
  const commit = () => {
    pending.current = false;
    onCommit();
  };

  return (
    <Input
      type="number"
      min={min}
      placeholder={placeholder}
      fontSize="14px"
      borderRadius={0}
      size="sm"
      width="88px"
      textAlign="right"
      name={name}
      value={value}
      onChange={e => {
        pending.current = true;
        onChange(e.target.value);
      }}
      onBlur={commit}
      onKeyDown={onEnter(commit)}
    />
  );
}

export const onEnter = fn => e => {
  if (e.key === 'Enter') {
    e.preventDefault();
    fn();
  }
};

// a line break in the label starts a new line
export function InfoTip({ label }) {
  return (
    <Tooltip label={label} whiteSpace="pre-line">
      <Box color="#666666" cursor="pointer">
        <Icons.Info size={20} />
      </Box>
    </Tooltip>
  );
}
